import React from 'react'
import './App.css';
import NavBar from './Components/NavBar';
import Oferta from './Components/Oferta';
import Cennik from './Components/Cennik';
import Kontakt from './Components/Kontakt';
import Karty from './Components/Karty';
import Mapa from './Components/mapa';
import Hero from './Components/Hero';
import Info from './Components/Info';
import Przyczepy from './Components/Przyczepy';
import Serwis from './Components/Serwis';

function App() {
  return (
    <>
    <NavBar />
    <Hero />
    <Oferta />
    <Mapa />
    <Przyczepy />
    <Karty />
    <Info />
    <Cennik />
    <Serwis />
    <Kontakt />
    </>
  )
}

export default App